// Region-Language-Currency 枚举表
// https://bytedance.feishu.cn/sheets/shtcnbHYD8w5uF0aU7JpQxlYPUf
export const currencyLocale = {
  BR: {
    currency: 'BRL',
    precision: 2,
    lang_code: 'pt-BR',
    apply_lang: ['es', 'fr', 'de', 'it', 'pt'],
    separator_symbol: ',',
  },
};

export default currencyLocale;
